import gql from "graphql-tag";

export default {
  update: gql`
    mutation UpdateCardsGameCell ($input: UpdateCardsGameCellInput!) {
      updateCardsGameCell (input: $input) {
        id
        cell_type
        card_1_uri
        card_2_uri
        card_3_uri
        card_4_uri
        card_5_uri
        card_6_uri
        card_7_uri
        card_8_uri
        verso_uri
        timer
        timer_color_1
        timer_color_2
        timer_color_3
        btn_start_color
        btn_start_text_color
        game{
          id
          game_type
          estimated_nb_players
        }
        fields {
          id
          type
          name
          label
          i18n {
            language_code
            label
          }
          required
          sort_order
          visible
          options {
            id
            form_field_id
            label
            i18n {
              language_code
              label
            }
          }
        }
        i18n {
          language_code
          image_uri
        }
      }
    }`,

  get: gql`
    query CardsGameCell($id: ID!) {
      cardsGameCell(id: $id) {
        id
        cell_type
        card_1_uri
        card_2_uri
        card_3_uri
        card_4_uri
        card_5_uri
        card_6_uri
        card_7_uri
        card_8_uri
        verso_uri
        timer
        timer_color_1
        timer_color_2
        timer_color_3
        btn_start_color
        btn_start_text_color
        fields {
          id
          type
          name
          label
          i18n {
            language_code
            label
          }
          required
          sort_order
          visible
          options {
            id
            form_field_id
            label
            i18n {
              language_code
              label
            }
          }
        }
        i18n {
          language_code
          image_uri
        }
      }
    }`
}
